export const MARKET_TIMEZONE = 'America/New_York';

export enum MiddlewareInjectToken {
    Config = 'Config',
    Cache = 'Cache',
    OrbisSdk = 'OrbisSdk',
    MiddlewareSdk = 'MiddlewareSdk',
    Sdks = 'Sdks',
}

export enum ApiInjectToken {
    BranchApi = 'BranchApi',
    ModelApi = 'ModelApi',
    GroupApi = 'GroupApi',
    UserApi = 'UserApi',
    AccountApi = 'AccountApi',
    MarketApi = 'MarketApi',
    TradingApi = 'TradingApi',
    QuoteApi = 'QuoteApi',
    WatchlistApi = 'WatchlistApi',
    ResearchApi = 'ResearchApi',
    StatApi = 'StatApi',
    NewsApi = 'NewsApi',
    TipranksApi = 'TipRanksApi',
    WebSocketApi = 'WebSocketApi',
    DocumentApi = 'DocumentApi',
}
